// extracted by mini-css-extract-plugin
module.exports = {"contentMargin":"LoginContainer_contentMargin__VZcL8","tabs":"LoginContainer_tabs__6V_Kn"};